"use strict";

exports.__esModule = true;

var _formatMetric = require("./formatMetric");

exports.formatMetric = _formatMetric.formatMetric;

var _formatDimension = require("./formatDimension");

exports.formatDimension = _formatDimension.formatDimension;

var _formatValue = require("./formatValue");

exports.formatValue = _formatValue.formatValue;

var _formatLabel = require("./formatLabel");

exports.formatLabel = _formatLabel.formatLabel;

var _getMetricsData = require("./getMetricsData");

exports.getMetricsData = _getMetricsData.getMetricsData;